import { useSelector } from 'react-redux';
import { matchRoutes, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { selectCurrentUserPermissions } from '@features/auth/store/selectors';
import { ROUTE_PERMISSION_MAP } from './routePermissions';
import { PERMISSIONS } from '@app/permissions/permissions';
import NoAccess from '@shared/components/others/NoAccess/NoAccess';

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const location = useLocation();
    const userPermissions: PERMISSIONS[] = useSelector(selectCurrentUserPermissions);

    const routePatterns = Object.entries(ROUTE_PERMISSION_MAP).map(([path, permission]) => ({
        path,
        permission,
    }));

    const matched = routePatterns.find(({ path }) => matchRoutes([{ path }], location)?.length);

    const requiredPermission = matched?.permission;

    if (requiredPermission && !userPermissions.includes(requiredPermission)) {
        return <NoAccess />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
